var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18185 7.36364C4.18185 10.3455 6.43639 12.7455 9.27276 13.1091V14.6364H6.36366C5.962 14.6364 5.63639 14.962 5.63639 15.3636C5.63639 15.7653 5.962 16.0909 6.36366 16.0909H13.6364C14.0381 16.0909 14.3637 15.7653 14.3637 15.3636C14.3637 14.962 14.0381 14.6364 13.6364 14.6364H10.7273V13.1091C13.5637 12.7455 15.8182 10.2727 15.8182 7.36364V4C15.8182 3.44772 15.3705 3 14.8182 3H5.18185C4.62956 3 4.18185 3.44772 4.18185 4V7.36364ZM2.72729 5.45455C2.72729 4.90226 3.17501 4.45455 3.72729 4.45455H4.18184L4.18185 7.36364H3.72729C3.17501 7.36364 2.72729 6.91592 2.72729 6.36364V5.45455ZM15.8182 4.45455H16.2727C16.825 4.45455 17.2728 4.90226 17.2728 5.45455V6.36364C17.2728 6.91592 16.825 7.36364 16.2728 7.36364H15.8182L15.8182 4.45455Z",
    fill: "url(#paint0_linear_5_19057)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.75L10.8419 6.34119H13.5665L11.3623 7.94263L12.2042 10.5338L10 8.93237L7.79581 10.5338L8.63773 7.94263L6.43354 6.34119H9.15807L10 3.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_19057",
    x1: 2.72729,
    y1: 9.54543,
    x2: 17.2728,
    y2: 9.54543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.aefdcb377a6944e189035dfd7fb865f2.svg";
export { ForwardRef as ReactComponent };